import React from 'react';

type Level = 'danger' | 'success' | 'warning' | 'info'

const AlertIcon = (props: { level: Level }) => {
  switch (props.level) {
    case 'danger':
      return (
        <div className="pxl-alert__icon-wrapper">
          <div className="pxl-alert__icon icon-reverse icon-circle">
            <i className="pxl-alert__icon icon-attention-alt" aria-hidden="true" />
          </div>
        </div>
      );

    case 'success':
      return (
        <div className="pxl-alert__icon-wrapper">
          <div className="pxl-alert__icon icon-reverse icon-circle">
            <i className="icon-check" aria-hidden="true" />
          </div>
        </div>
      );

    case 'warning':
      return (
        <div className="pxl-alert__icon-wrapper">
          <i className="pxl-alert__icon icon-warning" aria-hidden="true" />
        </div>
      );

    case 'info':
    default:
      return (
        <div className="pxl-alert__icon-wrapper">
          <i className="pxl-alert__icon icon-lightbulb" aria-hidden="true" />
        </div>
      );
  }
};

export default AlertIcon;
